import { useState } from 'react';
import { Box, Tab, Tabs, TextField, TextFieldProps } from '@mui/material';

interface LocaleEntry {
  value: string;
  label: string;
}

interface LocaleTabsFieldProps extends Omit<TextFieldProps, 'value' | 'onChange' | 'placeholder'> {
  locales: LocaleEntry[];
  value: Record<string, string>;
  onChange: (value: Record<string, string>) => void;
  placeholder: Record<string, string>;
}

export default function LocaleTabsField({
  locales,
  value,
  placeholder,
  onChange,
  ...textFieldProps
}: LocaleTabsFieldProps) {
  const [tab, setTab] = useState(0);
  const currentLocale = locales[tab]?.value ?? '';

  return (
    <Box>
      <Tabs
        value={tab}
        onChange={(_, v) => setTab(v)}
        sx={{ borderBottom: 1, borderColor: 'divider', mb: 2, minHeight: 36 }}
        TabIndicatorProps={{ style: { height: 2 } }}
      >
        {locales.map((l, i) => (
          <Tab
            key={l.value}
            label={l.label}
            value={i}
            sx={{ minHeight: 36, py: 0.5, fontSize: 14 }}
          />
        ))}
      </Tabs>

      <TextField
        {...textFieldProps}
        value={value[currentLocale] ?? ''}
        onChange={(e) => onChange({ ...value, [currentLocale]: e.target.value })}
        fullWidth
        placeholder={placeholder?.[currentLocale] ?? ''}
        size="small"
      />
    </Box>
  );
}
